import React, { useState, useEffect } from "react";
//@material-ui
import Grid from "@material-ui/core/Grid";

//datepicker
import ptBRLocale from "date-fns/locale/pt-BR";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { fcaTheme } from "./styles";
import { ThemeProvider } from "@material-ui/styles";

//custom components
import moment from "moment";
import OportunitySaturationLocal from "./OportunitySaturationLocal";
import SaturationFlow from "./SaturationFlow";

function SaturationPanel(props) {

  return (
    <Grid container spacing={3}>
      <Grid item md={12} lg={12} sm={12} xs={12}>
        <OportunitySaturationLocal
          start_day={props.start_day}
          end_day={props.end_day}
          routes={props.routes}
        />
      </Grid>
      <Grid item md={12} lg={12} sm={12} xs={12}>
        <SaturationFlow start_day={props.start_day} end_day={props.end_day} routes={props.routes}/>
      </Grid>
    </Grid>
  );
}

export default SaturationPanel;
